var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddVersion(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.378,
    height: 12.231,
    viewBox: "0 0 12.378 12.231",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.5 -3.3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.5 3.3)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#363a4a",
    width: 2.998,
    height: 5.438,
    transform: "translate(0 3.403)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#363a4a",
    width: 2.998,
    height: 8.579,
    transform: "translate(3.816 1.826)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#363a4a",
    d: "M0,0H4.746V12.231H0Z",
    transform: "translate(7.632 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddVersion);
export default __webpack_public_path__ + "static/media/addVersion.d5bad0c9fcc2d2c6ee77cffa6c517f87.svg";
export { ForwardRef as ReactComponent };